// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"6454":"Widgets","6821":"plone-volto-components-theme-InjectPloneComponentsCSS-InjectPloneComponentsCSS","7051":"plone-volto-components-manage-Controlpanels-Aliases"}[chunkId] + "." + {"6454":"b8a5b73a","6821":"6e1fe1b3","7051":"2b1266ba"}[chunkId] + ".chunk.css";
};